/* global LCCProjection */

import React, {useCallback, useState} from 'react';
import {QueryClientProvider} from 'react-query';
import {connect} from 'react-redux';

import proj4 from 'proj4';
import {register} from 'ol/proj/proj4';

import queryClient from 'topmeteo/utils/react-query';

import {generateDefinition} from '../utils/transform';

import FlightPlanningMap from './FlightPlanningMap';

let ID = 0;

const stringify = value => JSON.stringify(value, undefined, 2);

const Content = ({initialProjection, initialExtent, ...props}) => {
    const [{projection, extent}, setConfig] = useState({
        projection: initialProjection,
        extent: initialExtent,
    });

    const handleSubmit = useCallback(
        event => {
            event.preventDefault();

            const {target} = event;
            const extentNode = target.extent;
            const projectionParametersNode = target['projection-params'];

            const projection = `TM:LCC-${ID++}`;
            const extent = JSON.parse(extentNode.value);
            const projectionParameters = JSON.parse(projectionParametersNode.value);

            proj4.defs(projection, generateDefinition(projectionParameters));
            register(proj4);

            setConfig({
                projection,
                extent,
            });
        },
        [setConfig],
    );

    return (
        <QueryClientProvider client={queryClient}>
            <FlightPlanningMap {...props} projection={projection} extent={extent} />
            <form className="flight-planning-config-form" onSubmit={handleSubmit}>
                <label htmlFor="projection-params">
                    <span>Projection</span>
                    <textarea id="projection-params" cols={30} rows={10} defaultValue={stringify(LCCProjection)} />
                </label>
                <label htmlFor="extent">
                    <span>Extent</span>
                    <textarea id="extent" cols={10} rows={6} defaultValue={stringify(extent)} />
                </label>
                <button>Change</button>
            </form>
        </QueryClientProvider>
    );
};

const mapStateToProps = ({projection, extent}) => ({
    initialProjection: projection,
    initialExtent: extent,
});

export default connect(mapStateToProps)(Content);
